import { useNavigate } from "react-router-dom";
import { Button, Text } from "@chakra-ui/react";
import {
  CardInnerWrapper,
  CardText,
  MyOrganizationCard,
  MyOrganizationsPageWrapper,
  OrganizationsContainer,
  PageTitle,
} from "./Styles";
import { Union } from "../../Assets/SvgIcons";
import { OrganizationCard } from "../../Components/OrganizationCard/OrganizationCard";
import FullPageNexusLogoAnimation from "../../Reusable/FullPageNexusLogoAnimation/FullPageNexusLogoAnimation";
import { useOrganization } from "../../hooks/useOrganization";
import { useTierLimits } from "../../hooks/useTierLimits";

const MyOrganizations = () => {
  const navigate = useNavigate();
  const tierInfo = useTierLimits();
  const { myOrganizations, myOrganizationsLoading } = useOrganization();
  const canAddOrganization = tierInfo.isPaid || tierInfo.limits.organizations.canAdd;

  if (myOrganizationsLoading) {
    return <FullPageNexusLogoAnimation />;
  }

  if (myOrganizations && myOrganizations.length > 0)
    return (
      <>
        <MyOrganizationsPageWrapper data-cy="cypress-org-container">
          {canAddOrganization ? (
              <Button
                className="create-new-org-btn"
                onClick={() => navigate("/organizations/new")}
                type="submit"
                colorScheme="primary"
              >
                Create new
              </Button>
          ) : (
              <Text fontSize="sm" color="gray.600" mb={2}>
                Free tier: 1 organization max. Upgrade to paid ($19/month) to add more organizations.
              </Text>
          )}
          <PageTitle data-cy="cypress-my-organizations">My Organizations</PageTitle>
          <OrganizationsContainer data-cy="cypress-my-org-container">
            {myOrganizations?.map((org, index) => (
              <button
                onClick={() =>
                  navigate(`/organizations/${org.id}`, {
                    state: {
                      role: org.myRole,
                    },
                  })
                }
                key={org.id}
              >
                <OrganizationCard
                  image={org.image}
                  name={org.name}
                  type={org.type}
                  memberCount={org.memberCount}
                  cypressOrgId={`cypress-org-${index}`}
                />
              </button>
            ))}
          </OrganizationsContainer>
        </MyOrganizationsPageWrapper>
      </>
    );

  return (
    <MyOrganizationsPageWrapper>
      <MyOrganizationCard>
        <CardInnerWrapper>
          <Union boxSize={150} />
          <CardText data-cy='cypress-no-organizations'>You don't have any organizations.</CardText>
          {canAddOrganization ? (
            <Button
              onClick={() => navigate("/organizations/new")}
              type="submit"
              colorScheme="primary"
              data-cy='cypress-create-organizations'
            >
              Create a new organization
            </Button>
          ) : (
            <Text fontSize="sm" color="gray.600">
              Free tier: 1 organization max. Upgrade to paid ($19/month) to add more.
            </Text>
          )}
        </CardInnerWrapper>
      </MyOrganizationCard>
    </MyOrganizationsPageWrapper>
  );
};
export default MyOrganizations;
